import { FC, useEffect, useState } from "react";
import CountUp from "react-countup";
import Countdown from "react-countdown";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";

import {
  setIsLoggedIn,
  setSessionToken,
  setUserData,
  userState,
} from "../../store/user";

import SectionHeader from "../Layout/SectionHeader";
import Button from "../UI/Button";
import RouterButton from "../UI/RouterButton";
import InlineLoading from "../UI/InlineLoading";
import Modal from "../UI/Modal";

import classes from "./Wallet.module.css";
import { ArtworkModelDocument } from "../gallery/Gallery";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { getLang, i18n } from "../../i18n";

interface Props {
  setPopupImage: React.Dispatch<React.SetStateAction<string>>;
}

const Wallet: FC<Props> = ({ setPopupImage }) => {
  const lang = getLang();
  const t = i18n.profile[lang];

  const API_URL = process.env.REACT_APP_API_URL;
  const user = useSelector(userState);
  const dispatch = useDispatch();
  const [screenIsLoading, setScreenIsLoading] = useState(true);
  const [timeLeft, setTimeLeft] = useState(28800000);
  const [deckValue, setDeckValue] = useState(0);
  const [top10, setTop10] = useState([]);
  const [others, setOthers] = useState([]);
  const [copied, setCopied] = useState(false);
  const [cookies, setCookie] = useCookies(["access_token"]);
  const [snapshots, setSnapshots] = useState([]);
  const tickHandler = (time: number) => {
    setTimeLeft(time);
  };
  const [deleting, setDeleting] = useState(false);
  const getFreeTokensHandler = async () => {
    setTimeLeft(28800000);
    await axios
      .patch(
        `${API_URL}/users/freeTokens`,
        {},
        {
          withCredentials: true,
          headers: { Authorization: `Bearer ${user.sessionToken}` },
        }
      )
      .then((response) => {
        dispatch(setUserData(response.data.user));
        if (response.data.user.freeARTCtakenLeft) {
          setTimeLeft(response.data.user.freeARTCtakenLeft);
        } else {
          setTimeLeft(0);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const copyClickHandler = () => {
    navigator.clipboard.writeText(
      `https://app.raterart.com/?code=${user.inviteCode}`
    );
    setCopied(true);
  };
  const logoutClickHandler = () => {
    let expires = new Date();
    expires.setTime(expires.getTime() + 365 * 24 * 60 * 60 * 1000);
    setCookie("access_token", "", {
      path: "/",
      expires,
    });
    dispatch(setSessionToken(""));
    dispatch(setIsLoggedIn(false));
    window.location.href = "/";
  };
  const deleteClickHandler = () => {
    setDeleting(true);
  };
  const deleteUserClick = async () => {
    await axios
      .patch(
        `${API_URL}/users/delete`,
        {},
        {
          withCredentials: true,
          headers: { Authorization: `Bearer ${user.sessionToken}` },
        }
      )
      .then((response) => {
        dispatch(setUserData(response.data.user));
        if (response.data.user.freeARTCtakenLeft) {
          setTimeLeft(response.data.user.freeARTCtakenLeft);
        } else {
          setTimeLeft(0);
        }
        setDeleting(false);
      })
      .catch((error) => {
        console.log(error);
        setDeleting(false);
      });
  };
  const cancelDeleteClickHandler = async () => {
    await axios
      .patch(
        `${API_URL}/users/restore`,
        {},
        {
          withCredentials: true,
          headers: { Authorization: `Bearer ${user.sessionToken}` },
        }
      )
      .then((response) => {
        dispatch(setUserData(response.data.user));
        if (response.data.user.freeARTCtakenLeft) {
          setTimeLeft(response.data.user.freeARTCtakenLeft);
        } else {
          setTimeLeft(0);
        }
        setDeleting(false);
      })
      .catch((error) => {
        console.log(error);
        setDeleting(false);
      });
  };
  useEffect(() => {
    console.log("wallet use effect");
    // const getUserWallet = async () => {
    //   setScreenIsLoading(true);
    //   await axios
    //     .get(`${API_URL}/users/me`, {
    //       withCredentials: true,
    //       headers: { Authorization: `Bearer ${user.sessionToken}` },
    //     })
    //     .then((response) => {
    //       dispatch(setUserData(response.data.user));
    //       if (response.data.user.freeARTCtakenLeft) {
    //         setTimeLeft(response.data.user.freeARTCtakenLeft);
    //       } else {
    //         setTimeLeft(0);
    //       }
    //       setScreenIsLoading(false);
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       setScreenIsLoading(false);
    //     });
    // };

    const getUserDecks = async () => {
      setScreenIsLoading(true);
      await axios
        .get(`${API_URL}/decks`, {
          withCredentials: true,
          headers: { Authorization: `Bearer ${user.sessionToken}` },
        })
        .then((response) => {
          setDeckValue(response.data.deckValue);
          setTop10(response.data.top10);
          setOthers(response.data.others);
          setSnapshots(response.data.snapshots);
          setScreenIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setScreenIsLoading(false);
        });
    };

    //getUserWallet();
    getUserDecks();
  }, []);
  const expertRate =
    user.totalCorrectVotesCount &&
    user.totalFinishedBattlesVotesCount &&
    user.totalFinishedBattlesVotesCount >= 10
      ? user.totalCorrectVotesCount / user.totalFinishedBattlesVotesCount
      : 0;
  return (
    <>
      <SectionHeader
        label={
          user.userName ? user.userName : `${user.firstName} ${user.lastName}`
        }
      />

      <section className={classes.wallet}>
        <div className={classes.top}>
          <div className="container">
            {!screenIsLoading && (
              <div className={classes.deckValue}>
                <h2>{t.deckValue}</h2>
                <CountUp
                  className={classes.count}
                  duration={1}
                  start={0}
                  end={Math.round(deckValue)}
                  separator=","
                  suffix=" 💎"
                  decimals={0}
                />
              </div>
            )}

            {!screenIsLoading && top10.length > 0 && (
              <div className={classes.top10}>
                <div className={classes.rate}>
                  <h2>{t.myDeck}</h2>
                  <div className={classes.points}>{top10.length}/10</div>
                </div>

                <div className={classes.top10list}>
                  {top10.map((art: ArtworkModelDocument) => (
                    <div
                      key={art._id}
                      className={classes.img}
                      onClick={() => setPopupImage(art._id)}
                    >
                      <span className={classes.popupIcon}>{/* svg */}</span>
                      <img
                        src={art.imageAmazonS3ThumbURL || art.imageAmazonS3URL}
                        alt=""
                      />
                      <div className={classes.value}>
                        <span>{t.valueLabel}: </span>
                        <b>{art.value.toFixed(0)} 💎</b>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {!screenIsLoading && snapshots.length > 0 && (
              <>
                <h2>{t.deckValue}</h2>
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart data={snapshots}>
                    <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
                    <XAxis
                      dataKey="date"
                      tickFormatter={(date) =>
                        new Date(date).toLocaleDateString(
                          lang === "ru" ? "ru-RU" : "en-US",
                          {
                            month: "short",
                            day: "numeric",
                          }
                        )
                      }
                      minTickGap={10}
                    />
                    <YAxis domain={["dataMin - 100", "dataMax + 100"]} />
                    <Tooltip
                      labelFormatter={(date) =>
                        new Date(date).toLocaleDateString()
                      }
                    />
                    <Line
                      type="monotone"
                      dataKey="value"
                      stroke="#648bf4"
                      strokeWidth={3}
                      dot={false}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </>
            )}

            {!screenIsLoading && others.length > 0 && (
              <div className={classes.others}>
                <h2>{t.remainingArtworks}</h2>
                <div className={classes.nfts}>
                  {others.map((art: ArtworkModelDocument) => (
                    <div
                      key={art._id}
                      className={classes.img}
                      onClick={() => setPopupImage(art._id)}
                    >
                      <span className={classes.popupIcon}>{/* svg */}</span>
                      <img
                        src={art.imageAmazonS3ThumbURL || art.imageAmazonS3URL}
                        alt=""
                      />
                      <div className={classes.value}>
                        <span>{t.valueLabel}: </span>
                        <b>{art.value.toFixed(0)} 💎</b>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className={classes.flex}>
              <h2>{t.voteToEarn}</h2>
            </div>

            <p>{t.voteDescription}</p>

            <div className={classes.half}>
              <div className={classes.halfItem}>
                <div className={classes.rate}>
                  <h2>{t.expertRate}</h2>
                  <div className={classes.points}>
                    {user.totalCorrectVotesCount}/
                    {user.totalFinishedBattlesVotesCount}
                  </div>
                </div>

                {(user.totalFinishedBattlesVotesCount || 0) < 10 && (
                  <div className={classes.note}>{t.calculating}</div>
                )}
              </div>

              <div className={classes.halfItem} style={{ textAlign: "right" }}>
                <h2>{t.battleVoteReward}</h2>
                <div className={classes.count2}>
                  {(user.totalFinishedBattlesVotesCount || 0) >= 10 &&
                  (user.totalCorrectVotesCount || 0) /
                    (user.totalFinishedBattlesVotesCount || 0) >=
                    0.5
                    ? `${(0.4 * Math.pow(expertRate, 2)).toFixed(3)} 🌕`
                    : `0.01 🌕`}
                </div>
              </div>
            </div>

            <div className={classes.voteButtons}>
              <RouterButton label={t.voteNow} href="/vote" />
            </div>

            {(user.totalVotesCount || 0) > 0 && (
              <p className={classes.p}>
                {t.votedExtra}
                <br />
                <br />
                {t.votedInfoPrefix}{" "}
                <b style={{ fontSize: "125%" }}>{user.totalVotesCount}</b>{" "}
                {t.votedInfoSuffix}
              </p>
            )}
          </div>
        </div>

        <div className={classes.bottom}>
          <div className="container">
            <div className={classes.buttons}>
              <Button label={t.logout} onClick={logoutClickHandler} />

              {!user.isDeleted && (
                <Button
                  del
                  label={t.deleteProfile}
                  onClick={deleteClickHandler}
                />
              )}

              {user.isDeleted && (
                <Button
                  del
                  label={t.cancelDelete}
                  onClick={cancelDeleteClickHandler}
                />
              )}
            </div>
          </div>
        </div>
      </section>

      <Modal
        isShown={deleting}
        setIsShown={setDeleting}
        title={t.deleteModalTitle}
        question={t.deleteModalQuestion}
        btnLabel={t.deleteModalButton}
        btnClick={deleteUserClick}
      />
    </>
  );
};

export default Wallet;
